import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api';
import { PRODUCT_KEY, REMOTE_PRODUCT_SELECTED_KEY } from '../../constants';

export const loginUser = createAsyncThunk('login', async ({ email, password }) => {
  return await api.auth().signIn(email, password);
});

const loginSlice = createSlice({
  name: 'user',
  /**
   * @type {StateUser}
   */
  initialState: {
    isAuthenticated: false,
    loading: false,
    loginError: false
  },
  reducers: {
    localSignOut: (state, _action) => {
      state.isAuthenticated = false;
      localStorage.removeItem(REMOTE_PRODUCT_SELECTED_KEY)
      sessionStorage.removeItem(PRODUCT_KEY);
    },
    localSignIn: (state, _action) => {
      state.isAuthenticated = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state, _action) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state, _action) => {
        state.loading = false;
        state.user = _action.payload;
        state.isAuthenticated = true;
        state.loginError = false;
      })
      .addCase(loginUser.rejected, (state, _action) => {
        //TODO: Logique pour le statut error
        state.loading = false;
        state.loginError = true;
      });
  }
});

export const { localSignOut, localSignIn } = loginSlice.actions;

/**
 *
 * @param {StateUser} state
 * @returns {StateUser}
 */
export const selectUser = (state) => state.login;

export default loginSlice.reducer;
